import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <p>
        <span>
          © <span id="year">{new Date().getFullYear()}</span> - Designed &
          Developed by
          </span> 😎 <span>Irfan Qureshi</span> <span className="opacity-0">| </span>
          <span className="opacity-0">
            <Link to="/LetsLogin" className="login-0">
              Login
            </Link>
          </span>
      </p>
    </div>
  );
}

export default Footer;
